// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

export const walletAPI = {
  // GET /api/budget/reports/totals/
  getTotals: () => api.get('/api/budget/reports/totals/'),

  // GET /api/budget/profile/
  getWallet: () => api.get('/api/budget/profile/'),

  // PATCH /api/budget/profile/
  updateBalance: (balance) =>
    api.patch('/api/budget/profile/', { net_balance: balance }),

  // POST /api/budget/csv-import/upload/
  initialize: (data) =>
    api.post('/api/budget/csv-import/upload/', data),
};

// ── Helper: normalise totals response ─────────────────────────────
export function normaliseTotals(data) {
  const income = Number(data?.total_income ?? 0);
  const expense = Number(data?.total_expense ?? 0);
  const savings = Number(data?.total_savings ?? 0);
  return {
    total_income: income,
    total_expense: expense,
    total_savings: savings,
    net_balance: Number(data?.net_balance ?? income - expense - savings),
  };
}

export default walletAPI;
